import { css } from "@emotion/react";
import { Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import {
	createSearchParams,
	useNavigate,
	useSearchParams,
} from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useInventoryState } from "../../hooks/useInventoryState";
import { useThemeState } from "../../hooks/useThemeState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";

//-------------------------------------------------------------------------------------------------------
//export type ProductSearchBoxProps = {};
export const ProductSearchBox: React.FC /*<ProductSearchBoxProps>*/ = (
	_props,
) => {
	const translate = useTranslate();
	const theme = useThemeState().get().theme;
	const inventoryState = useInventoryState();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const keywords = searchParams.get("keywords") || "";

	// Use local state for the input value
	const [searchText, setSearchText] = useState(keywords || "");

	let inputPlaceholderText = translate("Search");
	if (inventoryState.get().catalog) {
		inputPlaceholderText += ` ${inventoryState.get().catalog?.Name ?? ""}`;
	}

	const doSearch = (searchText: string) => {
		navigate({
			pathname: `/inventory/${inventoryState.get().catalog?.Id}`,
			search: createSearchParams({
				keywords: searchText,
				pageno: "1",
			}).toString(),
		});
	};

	// Sync the search textbox with the keywords in the URL
	useEffect(() => {
		setSearchText(keywords);
		// eslint-disable-next-line
	}, [keywords]);

	return (
		<div
			css={css`
				position: relative;
				flex: 1 1 0;
				min-width: 300px;
				box-sizing: border-box;
				transition: all 1s;
				margin: 0 1rem;
			`}
		>
			<Input
				type="text"
				placeholder={inputPlaceholderText}
				className="pr-16"
				css={css`border-color:${theme.palette.siteTextPrimary};`}
				value={searchText}
				onChange={async (e) => {
					const searchText = (e.target as HTMLInputElement).value;
					setSearchText(searchText);
				}}
				onKeyUp={async (e) => {
					const searchText = (e.target as HTMLInputElement).value;
					if (e.key === "Enter") {
						doSearch(searchText);
					}
				}}
				onBlur={async (e) => {
					const searchText = (e.target as HTMLInputElement).value;
					if (searchText !== (keywords || "")) {
						doSearch(searchText);
					}
				}}
			/>
			<div className="absolute right-0 top-0 flex h-8 items-center">
				{searchText.length > 0 && (
					<Button
						type="button"
						size="icon"
						variant="ghost"
						aria-label="clear"
						onClick={async () => Promise.resolve().then(() => doSearch(""))}
					>
						<X css={css`color:${theme.palette.siteTextPrimary};`} />
					</Button>
				)}
				<Button type="button" size="icon" variant="ghost" aria-label="search">
					<Search css={css`color:${theme.palette.siteTextPrimary};`} />
				</Button>
			</div>
		</div>
	);
};
